// extracted by mini-css-extract-plugin
export var productImage = "_za-0";